import { timePickerDefaultProps } from '@code-monkey-ui/components/time-picker'
import { buildProps, definePropType } from '@code-monkey-ui/utils'

import type { ExtractPropTypes } from 'vue'
import type { IDatePickerType } from '../date-picker.type'

export const weekPickerProps = buildProps({
  ...timePickerDefaultProps,
  weekStart: {
    type: Number,
    default: 7,
  },
  type: {
    type: definePropType<IDatePickerType>(String),
    default: 'week',
  },
} as const)

export type WeekPickerProps = ExtractPropTypes<typeof weekPickerProps>
